/* eslint-disable no-restricted-syntax */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import clsx from 'clsx';
import { createChainedFunction } from '@atc/create-chained-function';
import { Select as ReaxlSelect } from 'reaxl';
import CommonFormComponent from '../hocs/CommonFormComponent';
import cleanFormProps from '../cleanFormProps';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const Select = /*#__PURE__*/memo(_ref => {
  let {
    disabled,
    formElementProps = {},
    value,
    id,
    isFlat = false,
    isFormDisabled,
    multiple,
    onChange,
    options,
    setValue,
    uiContext,
    ...rest
  } = _ref;
  const handleChange = event => {
    const target = event.currentTarget;
    let values;
    if (multiple) {
      values = [];
      // eslint-disable-next-line guard-for-in
      for (const i in target.options) {
        const option = target.options[i];
        if (option.selected) {
          values.push(option.value);
        }
      }
    } else {
      values = target.value;
    }
    setValue(values);
  };
  const renderElement = () => {
    const componentProps = ['attachToForm', 'columnClasses', 'detachFromForm', 'disabled', 'displayName', 'errorMessage', 'formElementProps', 'forwardedRef', 'getValue', 'hasValue', 'id', 'inline', 'innerRef', 'isFormDisabled', 'isFormSubmitted', 'isPristine', 'isRequired', 'isValid', 'isValidValue', 'maxSelectProps', 'minSelectProps', 'onChange', 'options', 'renderErrorMessage', 'renderHelp', 'rootClasses', 'resetValue', 'runValidation', 'setValidations', 'setValue', 'showError', 'showErrors', 'showRequired', 'validate', 'formElementProps'];
    const formProps = ['hasFeedback', 'propsToDelete'];
    const cleanedProps = cleanFormProps(rest, componentProps);
    const cleanFormElementProps = cleanFormProps(formElementProps, formProps);
    const chainedFunction = createChainedFunction(handleChange, onChange);
    const elementProps = {
      ...cleanedProps,
      ...cleanFormElementProps,
      value,
      onChange: chainedFunction,
      disabled: isFormDisabled || disabled,
      options,
      id,
      multiple,
      layout: uiContext
    };
    return /*#__PURE__*/_jsx(ReaxlSelect, {
      ...elementProps
    });
  };

  // when form is flat, hide select container and only display the value
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: clsx({
        hidden: isFlat
      }),
      children: renderElement()
    }), isFlat && /*#__PURE__*/_jsx("div", {
      children: value
    })]
  });
});
export default /* #__PURE__ */withFormsy(/* #__PURE__ */CommonFormComponent(Select));